/** Matches backend `LEGACY_SINGLE_SECTION_IMAGE_ID` for payload.media-only image rows. */
export const LEGACY_SINGLE_SECTION_IMAGE_ID = 'legacy-single-image';

export function normalizePayloadImageGalleryItems(raw) {
  if (!Array.isArray(raw)) return [];
  const out = [];
  for (const x of raw) {
    if (!x || typeof x !== 'object' || Array.isArray(x)) continue;
    const url = typeof x.url === 'string' ? x.url.trim() : '';
    const id = typeof x.id === 'string' ? x.id.trim() : '';
    const mt = typeof x.mediaType === 'string' ? x.mediaType.trim() : '';
    if (!url || !id) continue;
    if (!/^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i.test(id)) continue;
    if (!mt.toLowerCase().startsWith('image/')) continue;
    out.push({
      id,
      url,
      mediaType: mt,
      focalX: Number.isFinite(Number(x.focalX)) ? Math.min(1, Math.max(0, Number(x.focalX))) : 0.5,
      focalY: Number.isFinite(Number(x.focalY)) ? Math.min(1, Math.max(0, Number(x.focalY))) : 0.5,
      width: Number.isFinite(Number(x.width)) ? Math.round(Number(x.width)) : null,
      height: Number.isFinite(Number(x.height)) ? Math.round(Number(x.height)) : null,
      fileName: typeof x.fileName === 'string' && x.fileName.trim() ? x.fileName.trim() : null,
    });
  }
  return out;
}

/**
 * Ordered gallery items for a medias card: `payload.imageGallery` first, else a single legacy `media` image.
 * @param {{ imageGallery?: unknown }|null|undefined} payloadLike
 * @param {{ url?: string, mediaType?: string }|null|undefined} media
 */
export function resolveMediasImageGallery(payloadLike, media) {
  const fromGallery = normalizePayloadImageGalleryItems(payloadLike?.imageGallery);
  if (fromGallery.length > 0) return fromGallery;
  if (
    media &&
    typeof media === 'object' &&
    !Array.isArray(media) &&
    String(media.mediaType || '').toLowerCase().startsWith('image/') &&
    typeof media.url === 'string' &&
    media.url.trim()
  ) {
    return [
      {
        id: LEGACY_SINGLE_SECTION_IMAGE_ID,
        url: String(media.url).trim(),
        mediaType: String(media.mediaType || 'image/jpeg'),
        focalX: Number.isFinite(Number(media.focalX)) ? Math.min(1, Math.max(0, Number(media.focalX))) : 0.5,
        focalY: Number.isFinite(Number(media.focalY)) ? Math.min(1, Math.max(0, Number(media.focalY))) : 0.5,
        width: Number.isFinite(Number(media.width)) ? Math.round(Number(media.width)) : null,
        height: Number.isFinite(Number(media.height)) ? Math.round(Number(media.height)) : null,
        fileName: typeof media.fileName === 'string' && media.fileName.trim() ? media.fileName.trim() : null,
      },
    ];
  }
  return [];
}
